import {AbstractControl, ValidatorFn, Validators} from '@angular/forms';
import {retry} from 'rxjs/operator/retry';
/**
 * Created by cate on 21-09-17.
 */

const positiveFloatValidatorFunc = Validators.pattern(new RegExp('^(?![0.]+$)[0-9]+(\.[0-9]+)?$'));
const positiveIntegerValidatorFunc = Validators.pattern(new RegExp('^[0-9]*[1-9][0-9]*$'));
const slopeValidatorFunc = Validators.pattern(new RegExp('(^100$)|(^[0-9]?[0-9]$)'));
export class CintacValidators {

    // static listValidator(control: AbstractControl) {
    //     if (!control.value.startsWith('https') || !control.value.includes('.io')) {
    //         return {validUrl: true};
    //     }
    //     return null;
    // }
    static listValidator(members: String[]): ValidatorFn {
        return (control: AbstractControl) => {
            return members.indexOf(control.value) !== -1 ? null : {'listValidator': true};
        };
    }

    static windCondValidator(): ValidatorFn {
        const valueList = ['campo', 'ciudad'];
        return CintacValidators.listValidator(valueList);
    }

    static supportCondValidator(): ValidatorFn {
        const valueList = ['empotrado', 'rotulado'];
        return CintacValidators.listValidator(valueList);
    }

    static positiveFloatValidator() {
        return positiveFloatValidatorFunc;
    }

    static positiveIntegerValidator() {
        return positiveIntegerValidatorFunc;
    }

    static slopeValidator() {
        return slopeValidatorFunc;
    }

    static dummyValidator() {
        return () => {
            return;
        };
    }

    static getLateralLiningValidator(hasLateralLining: boolean) {
        if (hasLateralLining) {
            return Validators.required;
        } else {
            return this.dummyValidator;
        }
    }

    static getPositiveFloatValidatorMessage(): string {
        return 'Ingresar un número mayor a 0.';
    }

    static getPositiveIntegerValidatorMessage() {
        return 'Ingresar número mayor a 0 (entero).';
    }

    static getSlopeValidatorMessage() {
        return 'Ingresar número entre 0 y 100.';
    }

    static getListValidatorMessage(): string {
        return 'Valor inválido';
    }

    static getWindCondValidatorMessage(): string {
        return 'Valor de condición de viento inválido';
    }

    static getSupportCondValidatorMessage(): string {
        return 'Valor de condición de apoyo inválido';
    }

}



// WEBPACK FOOTER //
// ./src/app/_shared/cintac-validators.ts